import { ArrowUp } from "components/icons/generated";
import Badge from "ds/components/Badge";
import { BadgeVariants } from "ds/components/Badge/types";
import Box from "ds/components/Box";
import CardWrapper from "ds/components/Card/components/Wrapper";
import TooltipInfo from "ds/components/TooltipInfo";
import Typography from "ds/components/Typography";
import { RunObservabilitySeverity } from "types/generated";
import { IconComponent } from "types/Icon";
import { withTestId } from "utils/withTestId";

import { RUN_OBSERVABILITY_STAT_TILE_TEST_ID } from "./constants";
import styles from "./styles.module.css";
import { RunObservabilityStatTile, RunObservabilityStatTileComparison } from "./types";

const COMPARISON_BADGE_VARIANTS: Record<
  RunObservabilityStatTileComparison["severity"],
  BadgeVariants
> = {
  [RunObservabilitySeverity.None]: "green",
  [RunObservabilitySeverity.Minor]: "yellow",
  [RunObservabilitySeverity.Major]: "red",
};

const COMPARISON_BADGE_ICONS: Record<
  RunObservabilityStatTileComparison["severity"],
  IconComponent | undefined
> = {
  [RunObservabilitySeverity.None]: undefined,
  [RunObservabilitySeverity.Minor]: ArrowUp,
  [RunObservabilitySeverity.Major]: ArrowUp,
};

const RunObservabilityStatTileCard = ({
  id,
  label,
  value,
  valueColor,
  tooltip,
  comparison,
}: RunObservabilityStatTile) => (
  <CardWrapper
    className={styles.tile}
    padding="large"
    gap="medium"
    {...withTestId(`${RUN_OBSERVABILITY_STAT_TILE_TEST_ID}-${id}`)}
  >
    <Box direction="row" align="center" gap="small" zeroMinWidth>
      <Typography variant="p-t7" tag="span" color="primary">
        {label}
      </Typography>
      {tooltip && <TooltipInfo widthMode="maxWidthSm">{tooltip}</TooltipInfo>}
    </Box>

    <Box direction="row" align="center" gap="medium" wrap>
      <Typography variant="p-t3" tag="span" color={valueColor ?? "primary"}>
        {value}
      </Typography>
      {comparison && (
        <Badge
          type="weak"
          variant={COMPARISON_BADGE_VARIANTS[comparison.severity]}
          startIcon={COMPARISON_BADGE_ICONS[comparison.severity]}
          text={comparison.text}
        />
      )}
    </Box>
  </CardWrapper>
);

export default RunObservabilityStatTileCard;
